import { inject, Injectable } from '@angular/core';

import { ObjectMapperService } from '../../shared/model-serializer/object-mapper.service';

import { User } from './model/user.model';

import 'reflect-metadata';

@Injectable({
  providedIn: 'root',
})
export class UserTokenService {
  private readonly objectMapper = inject(ObjectMapperService);

  /**
   * decode the token
   * @return decoded token
   */
  public convertTokenToUser(token: string): User {
    try {
      if (token !== undefined && token !== null) {
        const encodedData: string = token.split('.')[1];
        const decoded: string = this.urlBase64Decode(encodedData);
        const decodedObj: User = this.objectMapper.deserialize(User, JSON.parse(decoded));
        return decodedObj;
      }
      throw new Error('No token available');
    } catch (error) {
      // TODO: use logger - problem: circular dependency
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  /**
   * decodes base64 encoded user auth token
   * @param  string str the token string
   * @return string
   */
  private urlBase64Decode(str: string): string {
    let output: string = str.replace('-', '+').replace('_', '/');
    switch (output.length % 4) {
      case 0: {
        break;
      }
      case 2: {
        output += '==';
        break;
      }
      case 3: {
        output += '=';
        break;
      }
      default: {
        throw new Error('Illegal base64url string!');
      }
    }
    // eslint-disable-next-line no-restricted-globals
    return window.atob(output);
  }
}
